export { default } from './SoldCar';
